// This file is auto-generated. Do not edit manually.

export enum DiagnosticLevel {
  Accessible = 0,
  Senior = 1,
  OneEtoile = 2,
  TwoEtoiles = 3,
  ThreeEtoiles = 4,
}
